"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InAppNotificationRegister = exports.InAppNotificationQuery = exports.InAppNotificationUpdate = exports.InAppNotification = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.InAppNotification = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    recipient: typebox_1.Type.String({ format: 'uuid' }),
    important: typebox_1.Type.Boolean(),
    statusLinked: typebox_1.Type.Boolean(),
    body: typebox_1.Type.String(),
    deliveredAt: typebox_1.Type.String({ format: 'date-time' }),
    linksTo: typebox_1.Type.Optional(typebox_1.Type.Object({
        entityType: typebox_1.Type.String(),
        entityId: typebox_1.Type.String(),
    })),
    readAt: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    deletedAt: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
});
exports.InAppNotificationUpdate = typebox_1.Type.Object({
    readAt: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    deletedAt: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
});
exports.InAppNotificationQuery = typebox_1.Type.Object({
    includeDeleted: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    limit: typebox_1.Type.Optional(typebox_1.Type.Number({ minimum: 1, maximum: 100 })),
    offset: typebox_1.Type.Optional(typebox_1.Type.Number({ minimum: 0 })),
});
exports.InAppNotificationRegister = typebox_1.Type.Object({
    register: typebox_1.Type.Literal(true),
});
//# sourceMappingURL=in-app-notification.js.map